export const VariantClasses = {
  image: 'overflow-hidden block bg-gray-100',
  text: 'inline-flex items-center justify-center bg-gray-500',
  anonymous: 'overflow-hidden bg-gray-100 block',
}

export const SizeClasses = {
  xs: 'h-6 w-6',
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-14 w-14',
}
